import { AdapExpansion } from './AdapExpansion';
import { AdapOrderby } from './AdapOrderby';
import { AdapPagination } from './AdapPagination';
import { AdapSearchfield } from './AdapSearchfield';
import { AdapSwiper } from './AdapSwiper';
import { MixinAdapRoute } from './MixinAdapRoute';
import { MixinAdapScreenSize } from './MixinAdapScreenSize';
var AdapTableWrapper = /** @class */ (function () {
    function AdapTableWrapper() {
    }
    Object.defineProperty(AdapTableWrapper, "screenSmall", {
        get: function () {
            if (this.options.screenBounds && this.options.screenBounds.small) {
                return this.options.screenBounds.small;
            }
            return 640;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapTableWrapper, "screenMedium", {
        get: function () {
            if (this.options.screenBounds && this.options.screenBounds.medium) {
                return this.options.screenBounds.medium;
            }
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdapTableWrapper, "screenLarge", {
        get: function () {
            if (this.options.screenBounds && this.options.screenBounds.large) {
                return this.options.screenBounds.large;
            }
            return 1024;
        },
        enumerable: true,
        configurable: true
    });
    AdapTableWrapper.install = function (Vue, options) {
        this.options = options || {};
        Vue.component('AdapExpansion', AdapExpansion);
        Vue.component('AdapSwiper', AdapSwiper);
        Vue.component('AdapOrderby', AdapOrderby);
        Vue.component('AdapPagination', AdapPagination);
        Vue.component('AdapSearchfield', AdapSearchfield);
    };
    AdapTableWrapper.options = {};
    return AdapTableWrapper;
}());
export default AdapTableWrapper;
export { AdapOrderby, AdapPagination, AdapSearchfield, MixinAdapRoute, MixinAdapScreenSize };
//# sourceMappingURL=index.js.map